var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useMemo, useState } from "react";
// components
import InputComponent from "../InputComponent";
import RadioType from "@frameworks/NCD/Components/RadioComponent/RadioComponent";
import actions from "@redux/feature/Markets/NCD/actions/TransactionJourneyActions";
import { useSelector } from "react-redux";
import FileUploadComponent from "../FileUploadComponent";
import AccordionComponent from "../AccordionComponent";
import { EHoldingTypeNCD, paymentOptions, } from "@frameworks/NCD/Constants/constant";
import ToastModal from "@frameworks/pmsjourney/components/common/toast";
import TransactionJourneyBankSelector from "../TransactionJourneyBankSelector";
var PaymentMode = function (_a) {
    var _b;
    var errorData = _a.errorData, setErrorData = _a.setErrorData;
    var cActions = new actions();
    var _c = __read(useState(false), 2), visible = _c[0], setVisible = _c[1];
    var orderBookDetails = useSelector(function (state) { return state.markets.Otc.orderBookReducer; }).orderBookDetails;
    var orderDetailsLocal = orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.data;
    var _d = useSelector(function (state) { return state.markets.Otc.transactionJourneyReducer; }), paymentMode = _d.paymentMode, bankDetails = _d.bankDetails, transactionId = _d.transactionId, transactionJourney = _d.transactionJourney, draftOrder = _d.draftOrder;
    var _e = __read(useState(""), 2), message = _e[0], setMessage = _e[1];
    var _f = __read(useState(false), 2), isRequired = _f[0], setIsRequired = _f[1];
    var _g = __read(useState(false), 2), isValid = _g[0], setIsValid = _g[1];
    var errorDataValidPaymentRefNo = ((_b = errorData === null || errorData === void 0 ? void 0 : errorData.status) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === "FAILURE" ? true : false;
    var validateField = function (name, value) {
        if (name === "rtgsNo")
            return value.length >= 3;
        if (name === "chequeNo")
            return /^[a-zA-Z0-9 ]*$/.test(value);
        return true;
    };
    var handleOnChangeInputs = function (name, value) {
        var _a;
        var updatedPayment = __assign(__assign({}, paymentMode), (_a = {}, _a[name] = value, _a));
        switch (name) {
            case "type":
                if (transactionId === null && !(orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.is_modify_cta)) {
                    setVisible(true);
                    setMessage("You can select payment mode only after entering the quantity ".concat(!(transactionJourney === null || transactionJourney === void 0 ? void 0 : transactionJourney.dirtyPrice) ? "and Dirty Price." : "."));
                    return;
                }
                else {
                    if (orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.is_modify_cta) {
                        updatedPayment = __assign(__assign({}, updatedPayment), { rtgsNo: "", chequeNo: "", bankName: null });
                        setErrorData({ error: null, isOpen: false });
                        cActions.updateUploadDeclarationValueProp(null);
                    }
                    else {
                        updatedPayment = __assign(__assign({}, updatedPayment), { rtgsNo: "", chequeNo: "" });
                    }
                    cActions.updateUploadDeclarationValueProp(null);
                }
                break;
            case "rtgsNo":
                setIsRequired(!validateField(name, value));
                break;
            case "chequeNo":
                setIsValid(!validateField(name, value));
                break;
        }
        cActions.updatePaymentModeValues(updatedPayment);
        cActions.updateValidSetUpFess(false);
    };
    var invalid = useMemo(function () { var _a; return ((_a = draftOrder === null || draftOrder === void 0 ? void 0 : draftOrder.data) === null || _a === void 0 ? void 0 : _a.status) === "Failure"; }, [draftOrder]);
    var renderBankDropdown = function () { return (React.createElement("div", { className: "d-flex align-items-start gap-2 new-mandate-section mt-4 mb-4" },
        React.createElement("div", { className: "w-100 dropdown-container" },
            React.createElement(TransactionJourneyBankSelector, { data: bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.data })))); };
    var renderFileUpload = function () { return (React.createElement("div", { className: "bank-upload" },
        React.createElement(AccordionComponent, { isDefalutKey: "0", items: [
                {
                    header: "Upload Transaction Proof",
                    body: (React.createElement(FileUploadComponent, { fileSize: 5, withoutApiFunctionality: Boolean(orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.is_modify_cta), localStateSaveCallback: function (data) {
                            var _a;
                            (orderDetailsLocal === null || orderDetailsLocal === void 0 ? void 0 : orderDetailsLocal.is_modify_cta) && console.log(data, "...");
                            cActions.updateUploadDeclarationValueProp(((_a = data === null || data === void 0 ? void 0 : data[0]) === null || _a === void 0 ? void 0 : _a.imageUrl) ? __spreadArray([], __read(data), false) : null);
                        } })),
                    optional: false,
                    leftIcon: null,
                    info: false,
                },
            ] }))); };
    var renderPaymentFields = function () {
        var _a, _b;
        switch (paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.type) {
            case EHoldingTypeNCD.RTGS:
                return (React.createElement(React.Fragment, null,
                    renderBankDropdown(),
                    React.createElement(InputComponent, { label: "RTGS No", placeholder: "Enter Transaction No", helperText: "", name: "rtgsNo", isInvalid: errorDataValidPaymentRefNo
                            ? errorDataValidPaymentRefNo
                            : invalid, errorText: errorDataValidPaymentRefNo
                            ? errorData === null || errorData === void 0 ? void 0 : errorData.message
                            : invalid
                                ? (_a = draftOrder === null || draftOrder === void 0 ? void 0 : draftOrder.data) === null || _a === void 0 ? void 0 : _a.message
                                : "", passErrorTextButHideErrTxt: true, onChangeEvent: function (event) {
                            handleOnChangeInputs("rtgsNo", event.target.value);
                        }, value: paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.rtgsNo, maxLength: 30, alphanum: true }),
                    renderFileUpload()));
            case EHoldingTypeNCD.Cheque:
                return (React.createElement(React.Fragment, null,
                    renderBankDropdown(),
                    React.createElement(InputComponent, { label: "Cheque No", placeholder: "Enter Cheque No", helperText: "", name: "chequeNo", required: true, isInvalid: errorDataValidPaymentRefNo
                            ? errorDataValidPaymentRefNo
                            : invalid, errorText: errorDataValidPaymentRefNo
                            ? errorData === null || errorData === void 0 ? void 0 : errorData.message
                            : invalid
                                ? (_b = draftOrder === null || draftOrder === void 0 ? void 0 : draftOrder.data) === null || _b === void 0 ? void 0 : _b.message
                                : "", passErrorTextButHideErrTxt: true, onChangeEvent: function (event) {
                            handleOnChangeInputs("chequeNo", event.target.value);
                        }, value: paymentMode.chequeNo, maxLength: 6, integer: true }),
                    renderFileUpload()));
            case EHoldingTypeNCD.NetBanking:
                return React.createElement(React.Fragment, null, renderBankDropdown());
            default:
                return null;
        }
    };
    return (React.createElement("div", { className: "payment_mode_otc_products" },
        React.createElement("label", { className: "ai-label DMSanN_14_400 mb-2 ms-1" }, "Payment mode"),
        React.createElement("div", { className: "bg_old_lace_primary p-1 DMsanL_10_300 txt_blackOne1 mb-14 payment_sub_copy" }, "Payment mode can be chosen later if not provided by the client."),
        React.createElement("div", { className: "aif-pms-radio" },
            React.createElement(RadioType, { recommendedType: EHoldingTypeNCD.RTGS, availableList: paymentOptions, selected: paymentMode.type, setPhysicalFlg: function (e) { return handleOnChangeInputs("type", e); } })),
        renderPaymentFields(),
        React.createElement(ToastModal, { visible: visible, setVisible: setVisible, message: message, isError: true })));
};
export default PaymentMode;
